import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadsPartnersComponent } from './components/leads-partners-at-a-glance/leads-partners.component';
import { LeadsPartnersRoutingModule } from './leads-partners.routing.module';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { LeadsPartnersInsightsComponent } from './components/leads-partners-insights/leads-partners-insights.component';
import { LeadsPartnersReportsComponent } from './components/leads-partners-reports/leads-partners-reports.component';
import { LeadsPartnersTransitionComponent } from './components/leads-partners-transition/leads-partners-transition.component';
import { LeadsPartnersUpgradeComponent } from './components/leads-partners-upgrade/leads-partners-upgrade.component';
import { RankingsByPartnerComponent } from './components/rankings-by-partner/rankings-by-partner.component';
import { LeadsPartnersService } from './services/leads-partners.service';

@NgModule({
    declarations: [
        LeadsPartnersComponent,
        LeadsPartnersInsightsComponent,
        LeadsPartnersReportsComponent,
        LeadsPartnersTransitionComponent,
        LeadsPartnersUpgradeComponent,
        RankingsByPartnerComponent,
    ],
    imports: [CommonModule, LeadsPartnersRoutingModule, SharedModule, ThirdPartyModule],
    providers: [LeadsPartnersService],
    schemas: [NO_ERRORS_SCHEMA],
})
export class LeadsPartnersModule {}
